// Vendor Libs
import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

// Dish Tech React
import {CrudDataTable, Overlay} from '@dishtech-react/core';
import {useForm, useOverlay, useService} from '@dishtech-react/hooks';

// Components
import ClientForm from './client-form';
import LoadingSpinner from '../layout/loading-spinner';

// Configs
import {serviceConfig} from '../../../config/service-config';
import {tableConfig} from '../../../config/table-config';

const SERVICE_KEY = 'CLIENT';

const Client = () => {
    const {serviceContent, registerService, unregisterService} = useService(SERVICE_KEY);
    const {registerForm, setFieldValues} = useForm(serviceConfig, SERVICE_KEY, 'update');
    const {content: clients} = serviceContent;
    const {columnHeaderThemeOverride, columns} = tableConfig[SERVICE_KEY];
    const fetching = useSelector(state =>
        state.service && state.service.CLIENT ? state.service.CLIENT.fetching : true
    );

    const {
        closeOverlay: closeCreateOverlay,
        open: isCreateOverlayOpen,
        openOverlay: openCreateOverlay,
        overlayId: createOverlayId,
    } = useOverlay({
        title: 'create_client',
    });
    const {
        closeOverlay: closeUpdateOverlay,
        open: isUpdateOverlayOpen,
        openOverlay: openUpdateOverlay,
        overlayId: updateOverlayId,
    } = useOverlay({
        title: 'update_client',
    });

    useEffect(() => {
        registerService();

        return () => unregisterService();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleUpdateButtonClick = clientId => {
        registerForm().then(() =>
            setFieldValues(clients.find(client => client.clientId === clientId)).then(() => {
                openUpdateOverlay();
            })
        );
    };

    return fetching ? (
        <LoadingSpinner />
    ) : (
        <>
            <CrudDataTable
                canCreate={true}
                canUpdate={true}
                columnConfig={columns}
                data={clients}
                headerConfig={columnHeaderThemeOverride}
                idKey="clientId"
                itemLabel="Client"
                options={{
                    selectableRows: 'none',
                }}
                title="Client Management"
                onCreate={openCreateOverlay}
                onUpdate={handleUpdateButtonClick}
            />
            <Overlay id={createOverlayId} open={isCreateOverlayOpen} title="Create Client">
                <ClientForm onCancel={closeCreateOverlay} onSave={closeCreateOverlay} />
            </Overlay>
            <Overlay id={updateOverlayId} open={isUpdateOverlayOpen} title="Update Client">
                <ClientForm mode="update" onCancel={closeUpdateOverlay} onSave={closeUpdateOverlay} />
            </Overlay>
        </>
    );
};

export default Client;
